import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from 'components/forms/new/formikFormFields/NameField';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const ProxyField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isInvalid={!!errors.proxy && touched.proxy}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>Proxy</FormLabel>
                <Field
                    name="proxy"
                    render={({ field }) => (
                        <NameField
                            {...field}
                            placeholder="Enter proxy server address"
                            className="!h-[30px] rounded-[5px] pl-2"
                            darkMode={darkMode}
                        />
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="The address of the outbound SIP proxy. All SIP messages will be sent to this URI. In many cases, this is the same as the Registrar URI. If unsure, check your provider's documentation.
Example: proxy.provider.com"
                        ariaLabel="registrar-proxy-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ProxyField;
